import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@javascript/components/utils"

const brandMarkVariants = cva("inline-flex items-center", {
  variants: {
    size: {
      sm: "gap-1.5 text-sm [&_svg]:size-4",
      md: "gap-2 text-lg [&_svg]:size-6",
      lg: "gap-2.5 text-2xl [&_svg]:size-8",
    },
  },
  defaultVariants: {
    size: "md",
  },
})

function BrandMark({
  className,
  size = "md",
  ...props
}: React.ComponentProps<"span"> &
  VariantProps<typeof brandMarkVariants>) {
  const uid = React.useId()
  const goldId = `brand-mark-gold-${uid}`
  const goldSoftId = `brand-mark-gold-soft-${uid}`

  return (
    <span
      data-slot="brand-mark"
      data-size={size}
      className={cn(brandMarkVariants({ size, className }))}
      {...props}
    >
      <svg viewBox="0 0 440 440" aria-hidden="true" focusable="false">
        <defs>
          <linearGradient id={goldId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#efd68f" />
            <stop offset="0.5" stopColor="#c8a24a" />
            <stop offset="1" stopColor="#8f6a25" />
          </linearGradient>
          <linearGradient id={goldSoftId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#f6e7b8" />
            <stop offset="1" stopColor="#c8a24a" />
          </linearGradient>
        </defs>
        <circle
          cx="175"
          cy="250"
          r="115"
          fill="none"
          stroke={`url(#${goldId})`}
          strokeWidth="7"
          strokeLinecap="round"
        />
        <circle
          cx="275"
          cy="200"
          r="115"
          fill="none"
          stroke={`url(#${goldId})`}
          strokeWidth="7"
          strokeLinecap="round"
        />
        <path d="M275 62 L292 82 L275 106 L258 82 Z" fill="#fff7dd" />
        <path
          d="M275 62 L292 82 L275 106 L258 82 Z"
          fill={`url(#${goldSoftId})`}
          stroke={`url(#${goldId})`}
          strokeWidth="2.5"
          strokeLinejoin="round"
        />
        <path
          d="M258 82 L292 82 M275 62 L275 106"
          stroke="#8f6a25"
          strokeWidth="1.2"
          opacity="0.55"
        />
        <circle cx="96" cy="150" r="5" fill="#f4e3ab" />
        <circle cx="372" cy="286" r="4" fill="#f4e3ab" />
        <circle cx="356" cy="118" r="3.5" fill="#f4e3ab" />
      </svg>
      <span>Goldypaper</span>
    </span>
  )
}

export { BrandMark, brandMarkVariants }
